import type { PropsWithChildren, ReactNode } from 'react'

import type { Nullable } from '@flecto/types'

export function findReactChildrenByDisplayName(
  children: PropsWithChildren['children'],
  displayName: string | string[]
): Nullable<ReactNode> {
  if (!Array.isArray(children)) return null

  const displayNames = Array.isArray(displayName) ? displayName : [displayName]

  const found = children.filter((child) =>
    displayNames.includes(child?.type?.displayName)
  )

  return found.length > 0 ? found : null
}
